'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formFieldUtils = require('../common/formFieldUtils');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var InputRadioField = (_temp2 = _class = function (_Field) {
  _inherits(InputRadioField, _Field);

  function InputRadioField() {
    var _temp, _this, _ret;

    _classCallCheck(this, InputRadioField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Field.call.apply(_Field, [this].concat(args))), _this), _this.onInputChange = function (text) {
      var onChange = _this.props.onChange;

      onChange({ value: { value: '-1', text: text } });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  InputRadioField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-input-radio'
    });
  };

  InputRadioField.prototype.getControlProps = function getControlProps() {
    var _props = this.props,
        showSearch = _props.showSearch,
        notFoundContent = _props.notFoundContent;

    var superProps = _Field.prototype.getControlProps.call(this);
    var value = this.getValue();

    return _extends({}, superProps, {
      style: _extends({}, superProps.style, { width: '100%' }),
      showSearch: showSearch,
      notFoundContent: notFoundContent,
      dataSource: this.dataSource,
      value: (0, _lodash.isObject)(value) && !(0, _lodash.isEmpty)(value) ? value.value : value,
      itemDirection: this.itemDirection
    });
  };

  InputRadioField.prototype.renderControl = function renderControl() {
    var controlProps = this.getControlProps();

    return _react2.default.createElement(_next.Radio.Group, controlProps);
  };

  _createClass(InputRadioField, [{
    key: 'itemDirection',
    get: function get() {
      var displayStyle = this.props.displayStyle;

      if (displayStyle === 'horizontal') {
        return 'hoz';
      } else if (displayStyle === 'vertical') {
        return 'ver';
      }
      return displayStyle;
    }
  }, {
    key: 'dataSource',
    get: function get() {
      var _this2 = this;

      var options = this.getOptions(true);
      var behavior = this.getBehavior();

      var _ref = this.getFieldValue() || {},
          value = _ref.value,
          text = _ref.text;

      var disabled = behavior === 'DISABLED';
      return options.map(function (item) {
        if (item.value === '-1' && value === item.value) {
          return {
            value: item.value,
            label: disabled ? text : _react2.default.createElement(
              'span',
              null,
              '\u5176\u4ED6\xA0',
              _react2.default.createElement(_next.Input, {
                value: text === '其他' ? null : text,
                disabled: disabled,
                onChange: _this2.onInputChange,
                placeholder: '\u8BF7\u8F93\u5165\u5185\u5BB9'
              })
            )
          };
        }
        return item;
      });
    }
  }]);

  return InputRadioField;
}(_vuFusionField2.default), _class.displayName = 'InputRadio', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, { displayStyle: 'vertical' }), _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), ['dataSource', {
  name: 'options',
  formatIn: function formatIn(options, props) {
    var dataSource = props.get('dataSource');
    var realOptions = [];
    if (Array.isArray(options) && !(0, _lodash.isEmpty)(options)) {
      realOptions = options;
    } else if (dataSource.value && !(0, _lodash.isEmpty)(dataSource.value.options)) {
      realOptions = dataSource.value.options;
    }
    if (!(0, _lodash.isEmpty)(realOptions)) {
      realOptions = realOptions.filter(function (item) {
        return item.text && !(0, _lodash.isNil)(item.value);
      });
    }
    // 添加其他选项
    realOptions.push({ text: '其他', value: '-1' });
    return realOptions;
  }
}, {
  name: 'fieldData',
  formatIn: function formatIn() {
    var fieldData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments[1];
    var states = arguments[2];
    var dataType = arguments[3];

    var defaultItems = (0, _formFieldUtils.getDefaultOptions)(states.options.value);
    if (!(0, _lodash.isEmpty)(fieldData.value)) {
      return fieldData;
    } else {
      return _extends({}, fieldData, { value: defaultItems[0] });
    }
  }
}]), _temp2);
exports.default = InputRadioField;
module.exports = exports['default'];